// .u_header

(function ($) {
  var $header = $('.u_header')
  $header.each(function (i, thisHeader) {
    headerInit($(thisHeader))
    headerInitMenu($(thisHeader))
  })

  function headerInit (thisHeader) {
    var $mobileButton = thisHeader.find('.u_header--menu-btn')
    $mobileButton.on('click', function () {
      thisHeader.toggleClass('isOpen')
      $('body').toggleClass('isMenuOpen')
    })
  }

  function headerInitMenu (thisHeader) {
    thisHeader.find('li.menu-item-has-children').append('<div class="menu-toggle">+</div>')
    thisHeader.find('.menu-toggle').click(function () {
      $(this).parent().toggleClass('isExpanded')
    })
  }
})(window.jQuery)
